import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { BlockType } from '@eluve/llm-outputs';

import { BlockTypeIcon } from './BlockTypeIcon';
import { templateBuilderStore } from './templateBuilderStore';

export const BlockPicker: React.FC<{
  parentId: UniqueIdentifier | null;
  index?: number;
  showTips?: boolean;
}> = ({ parentId, index, showTips }) => {
  const { t } = useTranslation();

  const blocks: {
    name: string;
    tip: string;
    type: BlockType;
  }[] = [
    {
      type: 'group',
      name: t('smartBlocks.blockPicker.groupName'),
      tip: t('smartBlocks.blockPicker.groupTip'),
    },
    {
      type: 'text',
      name: t('smartBlocks.blockPicker.textName'),
      tip: t('smartBlocks.blockPicker.textTip'),
    },
    {
      type: 'checkbox',
      name: t('smartBlocks.blockPicker.checkboxName'),
      tip: t('smartBlocks.blockPicker.checkboxTip'),
    },
  ];

  const onBlockClick = (blockType: BlockType) => {
    templateBuilderStore.send({
      parentId,
      type: 'addBlock',
      blockType,
      placeAtIndex: index,
    });
  };

  return (
    <Stack gap={3} direction="horizontal" align="stretch">
      {blocks.map(({ name, tip, type }, i) => {
        return (
          <React.Fragment key={i}>
            <Stack
              align="start"
              className="rounded-lg border p-4 hover:cursor-pointer hover:bg-bg-secondary"
              gap={1}
              onClick={() => onBlockClick(type)}
            >
              <Stack
                gap={3}
                justify={showTips ? 'start' : 'center'}
                direction="horizontal"
              >
                <BlockTypeIcon type={type} />
                <Text inline>{name}</Text>
              </Stack>
              {showTips && (
                <Text color="tertiary" size="xs">
                  {tip}
                </Text>
              )}
            </Stack>
          </React.Fragment>
        );
      })}
    </Stack>
  );
};
